import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { Grid, Typography, Chip } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import StudentCardProgress from "../../Components/ProgressBar/StudentCardProgress";
import { red } from "@mui/material/colors";
import Fade from "@mui/material/Fade";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const StudentCard = (props) => {
  const classes = useStyles();
  return (
    <Fade in={true} timeout={500}>
      <Box sx={{ display: "flex", justifyContent: "", mt: 2 }}>
        <Card
          className={classes.card}
          sx={{ boxShadow: "lg", cursor: "pointer", position: "relative" }}
          onClick={props.press}
        >
          <CardContent sx={{ py: 1, px: 0.5, textAlign: "center" }}>
            {props.title && (
              <Typography
                className={classes.ModuleNum}
                sx={{ color: "primary.main", lineHeight: 1 }}
              >
                {props.title}
              </Typography>
            )}
            {props.subtitle && (
              <Chip
                className={classes.SubTitle}
                color="primary"
                sx={{ color: "#FFFFFF" }}
                label={props.subtitle}
                size="small"
              />
            )}
            {props.secondarytitle && (
              <Typography
                className={classes.ModuleName}
                sx={{ color: "primary.main" }}
              >
                {props.secondarytitle}
              </Typography>
            )}
            {props.line1 && (
              <Typography
                className={classes.cardText}
                color="primary.main"
                sx={{ borderTop: 1, borderColor: "#D9D9D9" }}
              >
                {props.line1}
              </Typography>
            )}
            {props.line2 && (
              <Typography
                color="primary.main"
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.8rem",
                  textAlign: "center",
                }}
              >
                {props.line2}
              </Typography>
            )}
            <Typography sx={{ height: "24px" }}>
              {props.progress && <StudentCardProgress value={props.progress} />}
              {props.description && (
                <Typography
                  color="primary.main"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                    textAlign: "center",
                  }}
                >
                  {props.description}
                </Typography>
              )}
              {props.todayFutureTime && (
                <Typography
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    left: 10,
                    textAlign: "left",
                    color: red[500],
                    fontSize: "0.8rem",
                    fontWeight: "600",
                    "@media (min-width: 1636px)": {
                      fontSize: "1rem",
                    },
                  }}
                >
                  Future Assignment
                </Typography>
              )}
            </Typography>
          </CardContent>
          <CardActions
            sx={{ justifyContent: "space-between", py: 0, pb: 1, pt: 1 }}
          >
            <Grid>
              {props.leftBottom && (
                <Typography
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    left: 10,
                    textAlign: "left",
                    color: red[500],
                    fontSize: "0.8rem",
                    fontWeight: "600",
                    "@media (min-width: 1636px)": {
                      fontSize: "1rem",
                    },
                  }}
                >
                  {props.leftBottom && props.leftBottom == "Not Attempted"
                    ? props.leftBottom
                    : ""}
                </Typography>
              )}
            </Grid>
            <Grid>
              <IconButton
                aria-label="Go"
                size="small"
                sx={{
                  position: "absolute",
                  bottom: 10,
                  right: 10,
                  borderRadius: "50%",
                  backgroundColor: "#F5F5F5",
                  color: "primary.main",
                  padding: 0.5,
                  "@media (min-width: 1636px)": {
                    mt: 2,
                  },
                  
                }}
              >
                <ArrowForwardIosIcon
                  fontSize="inherit"
                  sx={{
                    fontSize: "1rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                />
              </IconButton>
            </Grid>
          </CardActions>
        </Card>
      </Box>
    </Fade>
  );
};

const useStyles = makeStyles({
  card: {
   background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)",
    width: "11rem",
    height: "14.5rem",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
    paddingTop: "1rem",
    "@media (min-width: 1636px)": {
      width: "16rem",
      height: "19rem",
    },
  },
  ModuleNum: {
    fontSize: "1rem",
    textAlign: "center",
    fontWeight: "900",
    wordWrap: "break-word",
    height: "5.2vh",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    "@media (min-width: 1636px)": {
      fontSize: "1.4rem",
      lineHeight: "1.1",
    },
  },
  ModuleName: {
    fontSize: "0.8rem",
    fontWeight: "500",
    textAlign: "center",
    fontWeight: "500",
    paddingBottom: 10,
    paddingTop: 5,
    height: "4.5vh",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    "@media (min-width: 1636px)": {
      fontSize: "1rem",
    },
  },
  SubTitle: {
    fontSize: "0.6rem",
    fontWeight: "500",
    textAlign: "center",
    fontWeight: "500",

    "@media (min-width: 1636px)": {
      fontSize: "1rem",
    },
  },
  cardText: {
    fontSize: "0.8rem",
    fontWeight: "500",
    textAlign: "center",
    paddingTop: 2,
    "@media (min-width: 1636px)": {
      fontSize: "1rem",
    },
  },
  className: {
    borderRadius: 20,
    textAlign: "center",
    color: "#8f9dd3",
    fontSize: "0.8rem",
    marginTop: 5,
    marginLeft: 10,
    marginRight: 10,
  },
});

export default StudentCard;
